import BrowserDetection from '@/services/BrowserDetection';

export default {
  methods: {
    getEmail() {
      // When compiled, all switch-statements are removed by webpack
      switch (APP_TARGET) {
        case "bmw": return 'bmwsupport@msm-network.com';
        case "lambo": return 'lamborghinisupport@msm-network.com';
        case "obi": return 'obisupport@msm-network.com';
        case "porsche": return 'porschesupport@msm-network.com';
        case "renault": return 'Renaultsupport@msm-network.com';
        default: return 'msmsupport@msm-network.com';
      }
    },

    getCustomLogoUrl() {
      switch (APP_TARGET) {
        case "bmw": return window.location.hostname.includes("bmwmotorrad") ? '/static/img/logo.bmwmoto.415x70px.png' : '/static/img/logo.bmw.415x70px.jpg';
        case "lambo": return '/static/img/logo.lamborghini.415x70px.png';
        case "aldisued": return '/static/img/logo.aldisued.83x100px.svg';
        case "ford": return '/static/img/logo-ford.png';
        case "jaguar": return '/static/img/logo-jaguar.png';
        case "obi": return '/static/img/Obi_366px.png';
        case "obinext": return '/static/img/obi-next-logo.png';
        case "porsche": return '/static/img/logo.porsche.415x70px.png';
        //case "renault": return '/static/img/Renault.png';
        case "vwag": return '/static/img/VWAG_Logo.png';
        case "audi": return '/static/img/Audi_Logo.png';
        case "db": return '/static/img/Logo_ServiceStoreDB.png';
        default: return null;
      }
    },

    isDemo() {
      switch (APP_TARGET) {
        case "ford": return true;
        case "jaguar": return true;
        case "vwag": return true;
        case "demo": return true;
        default: return false;
      }
    },

    hasDashboard() {
      return true;
    },

    hasDashboardCustomerSelection() {
      switch (APP_TARGET) {
        case "obi": return true;
        default: return false;
      }
    },

    hasCheckExplorer() {
      switch (APP_TARGET) {
        case "renault": return false;
        default: return true;
      }
    },

    hasComparision() {
      switch (APP_TARGET) {
        case "bmw": return true;
        default: return false;
      }
    },

    hasRawDataPointSelection() {
      switch (APP_TARGET) {
        case "audi": return false;
        default: return true;
      }
    },

    limitText(count) {
      return this.$t('Webportal.LimitText', { count });
    }
  },

  data() {
    return {
      toolTipDelay: { delay: { "show": 500, "hide": 100 } },
      browserIsIE: BrowserDetection.isIE()
    };
  }
};
